export default {
  path: "/SectionContent/CrashReportForms",
  name: "Crash Report Forms",
  htmlContent: "crash_report_forms.html",
  headings: [
    {
      id: "GDOT523GeorgiaMotorVehicleCrashReport",
      text: "GDOT-523 - Georgia Motor Vehicle Crash Report",
      type: "heading",
    },
    { id: "FrontOfCrashReport", text: "Front of Crash Report", type: "field" },
    { id: "BackOfCrashReport", text: "Back of Crash Report", type: "field" },
    { id: "SupplementContinuationSheet", text: "Supplement (Continuation) Sheet", type: "field" },
    { id: "AdditionalOrFullPageDiagram", text: "Additional or Full-Page Diagram", type: "field" },
    { id: "VehicleVsTrainCollisionForm", text: "Vehicle vs. Train Collision Form", type: "field" },
    { id: "Overlay", text: "Overlay", type: "heading" },
    {
      id: "GDOT314FARSEarlyTrafficFatalityNotificationForm",
      text: "GDOT-314 - FARS Early Traffic Fatality Notification Form",
      type: "heading",
    },
  ],
};
